export function capitalize(str: string): string {
    if (str.length === 0) {
        return str;
    }
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

const vowels = ["a", "e", "i", "o", "u"];
const esEndings = ["s", "x", "z", "ch", "sh", "o"];
const vesEndings = ["f", "fe"];

export function pluralize(word: string, count: number): string {
    const plural = count !== 1;

    if (!plural) {
        return word;
    }

    if (word.endsWith("y")) {
        if (vowels.includes(word[word.length - 2])) {
            return word + "s";
        } else {
            return word.substring(0, word.length - 1) + "ies";
        }
    }

    if (esEndings.some((ending) => word.endsWith(ending))) {
        return word + "es";
    }

    if (vesEndings.some((ending) => word.endsWith(ending))) {
        return word.substring(0, word.length - 1) + "ves";
    }

    return word + "s";
}

export function pluralizeWithCount(word: string, count: number): string {
    return `${count} ${pluralize(word, count)}`;
}

export function getPossessive(word: string): string {
    if (word.endsWith("'") || word.endsWith("'s")) {
        return word;
    }

    return word + (word.endsWith("s") ? "'" : "'s");
}

export function normalizeToString(value: any): string | null {
    if (value === undefined || value === null) {
        return null;
    }
    return String(value);
}

export function normalizeMatchableName(value: string): string {
    return value.trim().toLowerCase();
}

export function normalizeMatchableNames(values: string[]): string[] {
    return Array.from(
        new Set(
            values
                .map((value) => normalizeMatchableName(value))
                .filter((value) => value.length > 0),
        ),
    );
}

export function emptyToNull<T extends string>(
    value: T | null | undefined,
): T | null {
    if (value === "") {
        return null;
    }
    return value ?? null;
}

export function getFileExtension(fileName: string): string {
    const lastDot = fileName.lastIndexOf(".");
    if (lastDot < 0) {
        return "";
    }
    return fileName.slice(lastDot).toLowerCase();
}

export function camelCase(str: string): string {
    return str
        .replace(/[-_\s]+(.)?/g, (_, c: string | undefined) =>
            c ? c.toUpperCase() : "",
        )
        .replace(/^[A-Z]/, (c) => c.toLowerCase());
}

export function slugify(value: string): string {
    return value
        .normalize("NFKD")
        .replace(/\p{M}/gu, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
}
